import React, { useState, useRef, useEffect } from 'react';
import { DateRangePicker } from './DateRangePicker';

type FilterOption = string | { value: string; label: string };

interface DateFilterProps {
  onFilterChange: (filter: string, startDate?: Date, endDate?: Date) => void;
  filterOptions: FilterOption[];
  title: string;
  style?: string;
  width?: string;
  defaultValue?: string;
}

const Dropdown: React.FC<DateFilterProps> = ({
  onFilterChange,
  filterOptions,
  title,
  style,
  width,
  defaultValue,
}) => {
  const normalizeOption = (option: FilterOption) =>
    typeof option === 'string' ? { value: option, label: option } : option;

  const normalizedOptions = filterOptions.map(normalizeOption);
  const [filter, setFilter] = useState(defaultValue ?? normalizedOptions[0]?.value ?? 'All');
  const selectedLabel = normalizedOptions.find((opt) => opt.value === filter)?.label ?? filter;

  const [open, setOpen] = useState(false);

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleFilterChange = (e: { target: { value: string } }) => {
    const selected = e.target.value;
    setFilter(selected);

    if (selected !== 'CustomRange') {
      onFilterChange(selected);
    }
  };
  useEffect(() => {
    if (defaultValue !== undefined && defaultValue !== filter) {
      setFilter(defaultValue);
    }
  }, [defaultValue]);

  return (
    <div className="flex flex-col items-end gap-2">
      {/* Custom Dropdown */}
      <div ref={dropdownRef} className={`relative  ${width ? width : 'w-40 md:w-52'}`}>
        <div
          className={`bg-white border-green px-3 py-2 ml-auto rounded-lg flex items-end gap-2 ${style}`}
        >
          <span className="text-xs whitespace-nowrap text-[#A4A4A4] border-r border-green3 px-1 font-medium">
            {title}
          </span>
          <button onClick={() => setOpen(!open)} className="w-full min-w-0 flex-between gap-2">
            <span className="block min-w-0 truncate whitespace-nowrap text-black text-xs">{selectedLabel}</span>
            <svg
              className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : 'rotate-0'}`}
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>

        {open && (
          <ul className="absolute z-20 mt-1 w-full bg-white border-green rounded-lg shadow-lg max-h-60 overflow-y-auto">
            {normalizedOptions.map((opt) => (
              <li
                key={opt.value}
                onClick={() => {
                  handleFilterChange({ target: { value: opt.value } });
                  setOpen(false);
                }}
                className={`cursor-pointer text-black text-[11px] px-3 py-2 hover:bg-green/20 border-b-0 border-green ${
                  filter === opt.value ? 'bg-green/20 font-semibold' : ''
                }`}
              >
                {opt.label}
              </li>
            ))}
          </ul>
        )}
      </div>
      {filter === 'CustomRange' && (
        <DateRangePicker
          // value={selectedRange}
          // onChange={(newRange) => setSelectedRange(newRange)}
          // onApply={() => {
          //   setAppliedRange(selectedRange);
          //   setCurrentPage(1);
          // }}
          className="w-fit text-black"
        />
      )}
    </div>
  );
};

export default Dropdown;
